module.exports = __webpack_public_path__ + "img/logo.cceb0149.svg";